import { mdiCircle } from '@mdi/js';
import * as d3 from 'd3';
import _ from 'lodash';
import React from 'react';
import * as S from './pie-legend.styles';

export interface IPieLegendItem {
    name: string;
    amount?: number;
}

export interface IPieLegendProps {
    items: IPieLegendItem[];
}

export const PieLegend: React.FunctionComponent<IPieLegendProps> = (props: IPieLegendProps): React.ReactElement => {
    const { items } = props;

    const pctFormat = d3.format('.1~%');
    const amtFormat = d3.format('$,.2f');
    const total = _.sum(_.map(items, 'amount'));

    const pct = (amt: number): number => (total !== 0 ? amt / total : 0);
    const amount = (item: IPieLegendItem): number => _.get(item, 'amount', 0);

    const legendItems = items.map((item: IPieLegendItem, i: number) => (
        <S.LegendItem key={`${item.name}-${i}`} ord={i}>
            <S.LegendField>
                <S.LegendDot path={mdiCircle} ord={i} />
                {item.name}
            </S.LegendField>
            <S.LegendField>{pctFormat(pct(amount(item)))}</S.LegendField>
            <S.LegendField>{amtFormat(amount(item))}</S.LegendField>
        </S.LegendItem>
    ));

    return (
        <S.PieLegend>
            <table>
                <tbody>{legendItems}</tbody>
            </table>
        </S.PieLegend>
    );
};
